import React from 'react';
import _ from '@dh-fe/translate';
import FormattedMoney from 'components/FormattedMoney/FormattedMoney';
import Icon10kOranum from './assets/Icon10kOranum.svg';
import Icon5kOranum from './assets/Icon5kOranum.svg';
import Icon3kOranum from './assets/Icon3kOranum.svg';
import Icon1kOranum from './assets/Icon1kOranum.svg';

const placesOranum = {
    first: {
        place: '1st Place',
        award: _`[b]{amount}[/b]`.parseBB().toJSX({ amount: <FormattedMoney amount={1_000} currency="usd" /> }),
        icon: Icon10kOranum,
    },
    second: {
        place: '2nd Place',
        award: _`[b]{amount}[/b]`.parseBB().toJSX({ amount: <FormattedMoney amount={750} currency="usd" /> }),
        icon: Icon5kOranum,
    },
    third: {
        place: '3rd Place',
        award: _`[b]{amount}[/b]`.parseBB().toJSX({ amount: <FormattedMoney amount={500} currency="usd" /> }),
        icon: Icon3kOranum,
    },
    fourth: {
        place: '10 random giveaways',
        award: _`[b]{amount}[/b]*`
            .parseBB()
            .toJSX({ amount: <FormattedMoney amount={250} currency="usd" key={250} /> }),
        icon: Icon1kOranum,
    },
};

const getPrizes = (): typeof placesOranum => placesOranum;

export default getPrizes;
